// ============================================================
// Datei: src/pages/ressorts/InfrastrukturDesktop.jsx
//
// ÄNDERUNGEN:
// - ShiftTable jetzt mit departmentName + filterFn
// - Aufbau / Abbau bleiben sauber getrennt
// - automatische Aktualisierung bleibt erhalten
// - Guest-/Helper-Logik unverändert belassen
// ============================================================

import React, { useState } from "react";
import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import EditVolunteerModal from "../../../components/EditVolunteerModal";
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftPrintList from "../../../components/ShiftPrintList";

import "./infrastruktur.css";

const InfrastrukturDesktop = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	selectedVolunteer,
	setSelectedVolunteer,
	activeTab,
	downloadCcEmails,
	setActiveTab,
	reloadGuests,
	reloadVolunteers
}) => {
	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	// ============================================================
	// SHIFTS
	// ============================================================
	const infrastrukturAufbau = shifts.filter(
		(s) => s.shiftId >= 611 && s.shiftId <= 617
	);
	const infrastrukturAbbau = shifts.filter(
		(s) => s.shiftId >= 631 && s.shiftId <= 636
	);

	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{/* ================= HELPERS ================= */}
					{activeTab === "helpers" && (
						<div className="helpers-layout">
							<div className="helpers-column helpers-column-left">
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={(v) => setSelectedVolunteer(v)}
									reloadVolunteers={reloadVolunteers}
								/>
							</div>

							<div className="helpers-column helpers-column-right">
								<VolunteerPool
									departmentName="Infrastruktur"
									onAssigned={() => {
										if (reloadVolunteers) {
											reloadVolunteers();
										}
									}}
								/>
							</div>
						</div>
					)}

					{/* ================= SHIFTS ================= */}
					{activeTab === "shifts" && (
						<>
							<h3 className="infrastruktur-subheading">Aufbau</h3>
							<ShiftTable
								shifts={infrastrukturAufbau}
								departmentName="Infrastruktur"
								autoRefresh={true}
								filterFn={(shift) =>
									shift.shiftId >= 611 && shift.shiftId <= 617
								}
							/>

							<h3 className="infrastruktur-subheading">Abbau</h3>
							<ShiftTable
								shifts={infrastrukturAbbau}
								departmentName="Infrastruktur"
								autoRefresh={true}
								filterFn={(shift) =>
									shift.shiftId >= 631 && shift.shiftId <= 636
								}
							/>
						</>
					)}

					{/* ================= GUESTS ================= */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}
			{/* ================= Extras ================= */}
			{activeTab === "extras" && (
				<div className="kasse-extras-panel">
					<button
						className="cc-mail-card"
						onClick={downloadCcEmails}
						type="button"
					>
						<span className="cc-mail-icon">✉️</span>
						<span className="cc-mail-text">
							<span className="cc-mail-title">
								cc E-MailListe herunterladen
							</span>
							<span className="cc-mail-subtitle">
								Für Outlook &amp; Gmail geeignet
							</span>
						</span>
					</button>
				</div>
			)}
				</div>
			</div>
			
			{/* ================= EDIT VOLUNTEER ================= */}
			{selectedVolunteer && (
				<EditVolunteerModal
					volunteer={selectedVolunteer}
					onClose={() => setSelectedVolunteer(null)}
					onSaved={() => reloadVolunteers?.()}
				/>
			)}

			{/* ================= EDIT GUEST ================= */}
			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{/* ================= DELETE GUEST ================= */}
			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default InfrastrukturDesktop;